export const DEPT_INSURANCE = {
  yes: {
    id: 1,
    value: '1',
    label: 'Ja'
  },
  no: {
    id: 2,
    value: '2',
    label: 'Nein'
  }
};

export const DEPT_INSURANCE_OPTIONS = Object.values(DEPT_INSURANCE);

export const LOAN_AUTO_CALC_INFO = 'Bei aktivierter Berechnung werden Werte auch automatisch berechnet und über die ' +
  'Zeit aktualisiert. Bei deaktivierter Berechnung können Werte manuell erfasst werden.';

export const CATEGORY_DISABLED_INFO = "Diese Kategorie kann nicht geändert werden. Bitte klicken Sie auf " +
  "„Zurück“, um eine andere Kategorie auszuwählen.";